'use strict'

moment = require 'moment'
window.moment = moment
